import { defineMessages } from 'react-intl';

const messages = defineMessages({
  firstNameLabel: {
    id: 'App.ProspectProfile.ProspectProfileForm.FirstName.Label',
    defaultMessage: 'First Name *',
  },
  firstNamePlaceholder: {
    id: 'App.ProspectProfile.ProspectProfileForm.FirstName.Placeholder',
    defaultMessage: 'First name',
  },
  middleNameLabel: {
    id: 'App.ProspectProfile.ProspectProfileForm.MiddleName.Label',
    defaultMessage: 'Middle Name',
  },
  middleNamePlaceholder: {
    id: 'App.ProspectProfile.ProspectProfileForm.MiddleName.Placeholder',
    defaultMessage: 'Middle name',
  },
  lastNameLabel: {
    id: 'App.ProspectProfile.ProspectProfileForm.LastName.Label',
    defaultMessage: 'Last Name *',
  },
  lastNamePlaceholder: {
    id: 'App.ProspectProfile.ProspectProfileForm.LastName.Placeholder',
    defaultMessage: 'Last name',
  },
  suffixLabel: {
    id: 'App.ProspectProfile.ProspectProfileForm.Suffix.Label',
    defaultMessage: 'Suffix',
  },
  suffixPlaceholder: {
    id: 'App.ProspectProfile.ProspectProfileForm.Suffix.Placeholder',
    defaultMessage: 'Suffix',
  },
  preferredNameLabel: {
    id: 'App.ProspectProfile.ProspectProfileForm.PreferredName.Label',
    defaultMessage: 'Preferred Name',
  },
  preferredNamePlaceholder: {
    id: 'App.ProspectProfile.ProspectProfileForm.PreferredName.Placeholder',
    defaultMessage: 'Preferred name',
  },
  phoneLabel: {
    id: 'App.ProspectProfile.ProspectProfileForm.Phone.Label',
    defaultMessage: 'Primary Phone *',
  },
  secondaryPhoneLabel: {
    id: 'App.ProspectProfile.ProspectProfileForm.SecondaryPhone.Label',
    defaultMessage: 'Secondary Phone',
  },
  tertiaryPhoneLabel: {
    id: 'App.ProspectProfile.ProspectProfileForm.TertiaryPhone.Label',
    defaultMessage: 'Tertiary Phone',
  },
  phonePlaceholder: {
    id: 'App.ProspectProfile.ProspectProfileForm.Phone.Placeholder',
    defaultMessage: 'Phone',
  },
  phoneTypePlaceholder: {
    id: 'App.ProspectProfile.ProspectProfileForm.PhoneType.Placeholder',
    defaultMessage: 'Phone Type',
  },
  emailLabel: {
    id: 'App.ProspectProfile.ProspectProfileForm.Email.Label',
    defaultMessage: 'Primary Email *',
  },
  secondaryEmailLabel: {
    id: 'App.ProspectProfile.ProspectProfileForm.SecondaryEmail.Label',
    defaultMessage: 'Secondary Email',
  },
  tertiaryEmailLabel: {
    id: 'App.ProspectProfile.ProspectProfileForm.TertiaryEmail.Label',
    defaultMessage: 'Tertiary Email Address',
  },
  emailPlaceholder: {
    id: 'App.ProspectProfile.ProspectProfileForm.Email.Placeholder',
    defaultMessage: 'Email',
  },
  emailTypePlaceholder: {
    id: 'App.ProspectProfile.ProspectProfileForm.EmailType.Placeholder',
    defaultMessage: 'Email Type',
  },
  myNameIs: {
    id: 'App.ProspectProfile.ProspectProfileForm.Email.MyNameIs',
    defaultMessage: "Great! I'd love to help you with that. Again, my name is ",
  },
  mayIAsk: {
    id: 'App.ProspectProfile.ProspectProfileForm.Email.MayIAsk',
    defaultMessage: '. May I ask who I am speaking with?',
  },
  addPhone: {
    id: 'App.ProspectProfile.ProspectProfileForm.Phone.Add',
    defaultMessage: '+ Add Phone',
  },
  addEmail: {
    id: 'App.ProspectProfile.ProspectProfileForm.Email.Add',
    defaultMessage: '+ Add Email',
  },
  delete: {
    id: 'App.ProspectProfile.ProspectProfileForm.ContactInformation.Delete',
    defaultMessage: 'Delete',
  },
  removePhone: {
    id: 'App.ProspectProfile.ProspectProfileForm.Phone.Remove',
    defaultMessage: 'Remove Phone',
  },
  removeEmail: {
    id: 'App.ProspectProfile.ProspectProfileForm.Email.Remove',
    defaultMessage: 'Remove Email',
  },
});

export default messages;
